import { SOCIAL } from "../../data/mock";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy text-cream/80 py-14"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="font-display text-3xl text-cream">
            Amanda <span className="italic text-mustard">Abbott</span>
          </div>
          <p className="mt-3 text-sm max-w-xs">
            Brand, design, advocacy & curation — from Twin Waters to the world.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-mustard mb-3 font-semibold">
            Explore
          </div>
          <ul className="space-y-2 text-[15px]">
            <li><a href="#about" className="hover:text-cream transition-colors">About</a></li>
            <li><a href="#expertise" className="hover:text-cream transition-colors">Expertise</a></li>
            <li><a href="#editorial" className="hover:text-cream transition-colors">Editorial</a></li>
            <li><a href="#advocacy" className="hover:text-cream transition-colors">Advocacy</a></li>
            <li><a href="#book" className="hover:text-cream transition-colors">Book a call</a></li>
            <li><a href="/media-kit" className="hover:text-cream transition-colors">Media kit ↗</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-mustard mb-3 font-semibold">
            Connect
          </div>
          <ul className="space-y-2 text-[15px]">
            <li><a href={`mailto:${SOCIAL.email}`} className="hover:text-cream transition-colors">{SOCIAL.email}</a></li>
            <li><a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">Instagram</a></li>
            <li><a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">LinkedIn</a></li>
            <li><a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">Facebook</a></li>
            <li><a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">YouTube</a></li>
            <li><a href={SOCIAL.tiktok} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">TikTok</a></li>
            <li><a href={SOCIAL.pinterest} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">Pinterest</a></li>
            <li><a href={SOCIAL.coroflot} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">Coroflot</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 mt-12 pt-6 border-t border-cream/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/60">
        <span>© {year} Amanda Abbott. All rights reserved.</span>
        <span>Built with care on the Sunshine Coast.</span>
      </div>
    </footer>
  );
}
